import React from "react";
import {
  Form,
  Input,
  Select,
  Radio,
  Checkbox,
  Button,
  Collapse,
  Row,
  Col,
  Typography,
  Space,
  Divider,
  Spin,
} from "antd";

const { Text } = Typography;

type PatientRegistrationProps = {
  form: any;
  handleVerifyMobile: any;
  handleVerifyOtp: any;
  isOtpVerified: boolean;
  isMobileVerified: boolean;
  handleSubmit: any;
  isSubmitting: boolean;
  isOtpVerifying: boolean;
  isMobileVerifying: boolean;
};

const PatientRegistration: React.FC<PatientRegistrationProps> = ({
  form,
  handleVerifyMobile,
  handleVerifyOtp,
  isMobileVerified,
  isOtpVerified,
  handleSubmit,
  isSubmitting,
  isOtpVerifying,
  isMobileVerifying
}) => {
  const attendant = Form.useWatch("attendant", form);
  const relationship = Form.useWatch("relationship", form);

  const relationshipOptions = [
    { label: "Mother", value: "Mother" },
    { label: "Father", value: "Father" },
    { label: "Son", value: "Son" },
    { label: "Daughter", value: "Daughter" },
    { label: "Wife", value: "Wife" },
    { label: "Husband", value: "Husband" },
    { label: "Mother-in-law", value: "Mother-in-law" },
    { label: "Father-in-law", value: "Father-in-law" },
    { label: "Other", value: "Other" },
  ];

  const onFinish = async (values: any) => {
    try {
      await form.validateFields();
      handleSubmit();
    } catch (err) {}
  };

  return (
    <div
      style={{
        maxWidth: 420,
        margin: "auto",
        background: "#f5f7fb",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          padding: "8px 16px",
          background: "white",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
        }}
        className="patient-registration"
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          initialValues={{
            attendant: "self",
          }}
        >
          <div style={{ marginBottom: 24 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: "#004C8F",
                }}
              >
                Patient Registration
              </span>

              <div
                style={{
                  width: 12,
                  height: 12,
                  background: "#2ecc71",
                  borderRadius: "50%",
                }}
              />
            </div>

            <div
              style={{
                border: "1px solid #AADFFF",
                padding: "8px 16px",
                borderRadius: "10px",
              }}
            >
              <Text strong style={{ fontSize: "11px", marginBottom: "0.4rem" }}>
                Communication Address
              </Text>

              {/* <Form.Item name="sameAddress" valuePropName="checked">
              <Checkbox>
                Current communication address is same as card address
              </Checkbox>
            </Form.Item> */}
              <Row gutter={[2, 2]} style={{ marginTop: "10px" }}>
                <Col span={24}>
                  {/* <Form.Item
                    label={
                      <span style={{ fontSize: "10px", padding: 0, margin: 0 }}>
                        Pincode
                      </span>
                    }
                    name="pincode"
                    rules={[
                      { required: true, message: "Pincode is required!" },
                    ]}
                    style={{ fontSize: "10px" }}
                    labelCol={{ span: 0 }}
                  >
                    <Input
                      placeholder="Pincode"
                      style={{ fontSize: "10px" }}
                    />
                  </Form.Item> */}
                  <Form.Item
                    name="pincode"
                    rules={[
                      { required: true, message: "Pincode is required!" },
                    ]}
                    style={{ marginBottom: 10 }}
                  >
                    <div className="floating-input">
                      <Input
                        style={{ fontSize: "10px" }}
                        placeholder=" "
                        className="input-field"
                      />
                      <label className="floating-label">
                        Pincode <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  {/* <Form.Item
                    label={
                      <span style={{ fontSize: "10px", padding: 0, margin: 0 }}>
                        Village / Town / City
                      </span>
                    }
                    name="city"
                    rules={[
                      {
                        required: true,
                        message: "Village / Town / City is required!",
                      },
                    ]}
                    style={{ fontSize: "10px" }}
                    labelCol={{ span: 0 }}
                  >
                    <Input
                      placeholder="Village / Town / City"
                      style={{ fontSize: "10px" }}
                    />
                  </Form.Item> */}
                  <Form.Item
                    name="city"
                    rules={[
                      {
                        required: true,
                        message: "Village / Town / City is required!",
                      },
                    ]}
                    style={{ marginBottom: 10 }}
                  >
                    <div className="floating-input">
                      <Input
                        style={{ fontSize: "10px" }}
                        placeholder=" "
                        className="input-field"
                      />

                      <label className="floating-label">
                        Village / Town / City{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </div>

          {/* Attendant Details */}
          <div
            style={{
              border: "1px solid #AADFFF",
              padding: "8px 16px",
              borderRadius: "10px",
            }}
          >
            <Text strong style={{ fontSize: "11px", marginBottom: "0.4rem" }}>
              Attendant Details
            </Text>

            <Row gutter={[2, 2]} style={{ marginTop: "6px" }}>
              <Col span={24}>
                <Form.Item name="attendant">
                  <Radio.Group className="custom-radio">
                    <Space>
                      <Radio value="self">Self</Radio>
                      <Radio value="other">Other</Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </Col>

              {attendant?.toLowerCase() === "other" ? (
                <Col span={24}>
                  <Form.Item
                    name="fullName"
                    // rules={[{ required: true, message: "Name is required!" }]}
                    style={{ marginBottom: 10 }}
                  >
                    <div className="floating-input">
                      <Input
                        style={{ fontSize: "10px" }}
                        placeholder=" "
                        className="input-field"
                      />
                      <label className="floating-label">
                        Full Name 
                        {/* <span style={{ color: "red" }}>*</span> */}
                      </label>
                    </div>
                  </Form.Item>
                </Col>
              ) : (
                <></>
              )}

              {attendant?.toLowerCase() === "other" ? (
                <Col span={24}>
                  <div className="floating-wrapper">
                    <label className="floating-static-label">
                      Relationship 
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </label>
                    <Form.Item
                      name="relationship"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Relationship is required!",
                      //   },
                      // ]}
                      style={{ marginBottom: 10 }}
                    >
                      <Select
                        showSearch
                        placeholder="Select Relationship"
                        className="input-field filter-select"
                        dropdownClassName="filter-select-dropdown"
                        style={{
                          fontSize: "10px",
                          width: "100%",
                          padding: "2px 4px",
                        }}
                        allowClear
                        dropdownStyle={{ fontSize: "10px" }}
                        optionFilterProp="label"
                      >
                        {relationshipOptions?.map((option) => (
                          <Select.Option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
              ) : (
                <></>
              )}

              {relationship?.toLowerCase() === "other" ? (
                <Col span={24}>
                  <Form.Item
                    name="otherRelation"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Other Relation is required!",
                    //   },
                    // ]}
                    style={{ marginBottom: 10 }}
                  >
                    <div className="floating-input">
                      <Input
                        style={{ fontSize: "10px" }}
                        placeholder=" "
                        className="input-field"
                      />
                      <label className="floating-label">
                        Other Relation 
                        {/* <span style={{ color: "red" }}>*</span> */}
                      </label>
                    </div>
                  </Form.Item>
                </Col>
              ) : (
                <></>
              )}

              <Col span={24}>
                <Form.Item
                  name="mobileNumber"
                  rules={[
                    { required: attendant?.toLowerCase() === "other" ? false : true, message: "Mobile Number is required!" },
                    {
                      pattern: /^[6-9]/,
                      message: "Number start with 6, 7, 8, or 9!",
                    },
                    {
                      pattern: /^\d{10}$/,
                      message: "Number must be 10 digits!",
                    },
                    {
                      pattern: /^[6-9]\d{9}$/,
                      message: "Numeric values are allow!",
                    },
                  ]}
                  style={{ marginBottom: 10 }}
                >
                  <div className="floating-input">
                    <Input
                      style={{ fontSize: "10px", color: "black" }}
                      placeholder=" "
                      className="input-field"
                      maxLength={10}
                      inputMode="numeric"
                      disabled={isMobileVerified}
                    />
                    <label className="floating-label">
                      Mobile Number 
                      {attendant?.toLowerCase() !== "other" && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </label>
                    {isMobileVerifying ? <Spin size="small" style={{
                          position: "absolute",
                          right: 10,
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "10px",
                          color: "#004C8F",
                          // cursor: "pointer",
                          userSelect: "none",
                          fontWeight: "600",
                        }}/> : !isMobileVerified ? (
                      <span
                        onClick={handleVerifyMobile}
                        style={{
                          position: "absolute",
                          right: 10,
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "10px",
                          color: "#004C8F",
                          // cursor: "pointer",
                          userSelect: "none",
                          fontWeight: "600",
                        }}
                      >
                        Verify
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={10}>
              <Col span={16}>
                <Form.Item
                  name="otp"
                  rules={[
                    { required: attendant?.toLowerCase() === "other" ? false : true, message: "OTP is required!" },
                    // {
                    //   pattern: /\d{9}$/,
                    //   message: "Numeric values are allow!",
                    // },
                  ]}
                  style={{ marginBottom: 10 }}
                >
                  <div className="floating-input">
                    <Input
                      style={{ fontSize: "10px", color: "black" }}
                      placeholder=" "
                      className="input-field"
                      inputMode="numeric"
                      disabled={isOtpVerified}
                    />
                    <label className="floating-label">
                      OTP 
                      {attendant?.toLowerCase() !== "other" && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </label>
                  </div>
                </Form.Item>
              </Col>

              <Col span={8}>
                <Button
                  type="primary"
                  style={{
                    width: "100%",
                    color: "white"
                  }}
                  onClick={handleVerifyOtp}
                  className="patient-reg-btn"
                  disabled={!isMobileVerified || isOtpVerified}
                  loading={isOtpVerifying}
                >
                  Verify
                </Button>
              </Col>
            </Row>
          </div>

          <Button
            type="primary"
            htmlType="submit"
            block
            size="small"
            style={{
              borderRadius: 6,
              background: "#004C8F",
              marginTop: "10px",
              color: "white"
            }}
            disabled={!(isMobileVerified && isOtpVerified)}
            loading={isSubmitting}
          >
            Submit
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default PatientRegistration;
